import React from 'react';
const context = React.createContext({
    currentModalZIndex: 100,
    setCurrentModalZIndex: () => { },
});
export const { Provider, Consumer } = context;
export default context;
